module.exports = __webpack_public_path__ + "img/撕毁防伪.f44ab99b.png";